import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import FloatCard from './FloatCard';

const SHADOW_BY_ACCENT_COLOR = {
  highlight: 'drop-shadow-[0px_0px_6px_rgba(224,_21,_122,_0.2)]',
  info: 'drop-shadow-[0px_0px_6px_rgba(35,_204,_235,_0.2)]',
  secondary: 'drop-shadow-[0px_0px_6px_rgba(113,_22,_233,_0.2)]',
};

const STROKE_BY_ACCENT_COLOR = {
  highlight: 'dark:stroke-highlight-200',
  info: 'dark:stroke-info-200',
  secondary: 'dark:stroke-secondary-200',
};

const BORDER_BY_ACCENT_COLOR = {
  highlight: 'border-highlight-300',
  info: 'border-info-300',
  secondary: 'border-secondary-300',
};

const PuzzleCard = ({
  accentColor,
  clicks,
  companyName,
  ctrPercent,
  epoch,
  logo,
  pageViews,
}) => (
  <div className="relative h-[402px] w-[324px]">
    <FloatCard
      shadowClassName={twJoin(
        'dark:drop-none z-2',
        SHADOW_BY_ACCENT_COLOR[accentColor]
      )}
      strokeClassName={STROKE_BY_ACCENT_COLOR[accentColor]}
    >
      <Image
        alt={companyName}
        className="brightness-[.15] dark:brightness-150"
        height={64}
        src={logo}
        width={90}
      />
      <Heading className="mb-4 mt-2" size="size6">
        {epoch}
      </Heading>
      <div>
        <Heading size="size2">+{pageViews} mil</Heading>
        <Text size="size2">Pageviews</Text>
      </div>
      <div>
        <Heading className="mt-6" size="size2">
          +{clicks} mil
        </Heading>
        <Text size="size2">Clicks</Text>
      </div>
      <Heading className="mt-12 self-end" size="size5">
        CTR {ctrPercent}%
      </Heading>
    </FloatCard>
    <div
      className={twJoin(
        'absolute bottom-0 right-0 -z-1',
        'h-[343px] w-[277px] rounded-4 border-2 border-solid',
        BORDER_BY_ACCENT_COLOR[accentColor]
      )}
    />
  </div>
);

PuzzleCard.propTypes = {
  accentColor: PropTypes.string.isRequired,
  clicks: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  ctrPercent: PropTypes.number.isRequired,
  epoch: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  pageViews: PropTypes.number.isRequired,
};

export default PuzzleCard;
